import React from "react";
import s from "./CourseContentSection.module.scss";

export type VideoItem = {
    file: File | null;
    previewUrl: string | null;
    title: string;
    isDemo?: boolean;
};

interface Props {
    description: string;
    videos: VideoItem[];
    onDescriptionChange: (val: string) => void;
    onVideosChange: (items: VideoItem[]) => void;
}

export const CourseContentSection: React.FC<Props> = ({
                                                          description,
                                                          videos,
                                                          onDescriptionChange,
                                                          onVideosChange,
                                                      }) => {
    const handleSelect = (idx: number, file: File | null) => {
        const next = [...videos];
        const prevUrl = next[idx]?.previewUrl;
        if (prevUrl) URL.revokeObjectURL(prevUrl);

        if (file) {
            const url = URL.createObjectURL(file);
            next[idx] = { ...(next[idx] ?? {}), file, previewUrl: url };
        } else {
            next[idx] = { ...(next[idx] ?? {}), file: null, previewUrl: null };
        }
        onVideosChange(next);
    };

    const handleTitle = (idx: number, val: string) => {
        const next = [...videos];
        next[idx] = { ...(next[idx] ?? {}), title: val };
        onVideosChange(next);
    };

    const handleDemoToggle = (idx: number) => {
        const next = [...videos];
        next[idx] = { ...(next[idx] ?? {}), isDemo: !next[idx]?.isDemo };
        onVideosChange(next);
    };

    const removeVideoBlock = (idx: number) => {
        const next = [...videos];
        const prevUrl = next[idx]?.previewUrl;
        if (prevUrl) URL.revokeObjectURL(prevUrl);
        next.splice(idx, 1);
        onVideosChange(next);
    };

    const addSlot = () => {
        onVideosChange([...videos, { file: null, previewUrl: null, title: "", isDemo: false }]);
    };

    return (
        <div className={s.wrapper}>
            <h2 className={s.sectionTitle}>Описание товара</h2>
            <div className={s.textareaGroup}>
                <textarea
                    className={s.textarea}
                    placeholder="Опишите, о чем будет курс"
                    value={description}
                    onChange={(e) => onDescriptionChange(e.target.value)}
                />
            </div>

            <div className={s.headerLine}></div>

            <h2 className={s.sectionTitle}>Видео</h2>
            <div className={s.videosStack}>
                {videos.map((v, i) => (
                    <div key={i} className={s.videoRow}>
                        <div className={s.videoDrop}>
                            {v.previewUrl ? (
                                <video className={s.videoPreview} src={v.previewUrl}/>
                            ) : (
                                <>
                                    <input
                                        className={s.hiddenInput}
                                        type="file"
                                        accept="video/*"
                                        onChange={(e) => handleSelect(i, e.target.files?.[0] ?? null)}
                                    />
                                    <div className={s.addIcon}>
                                        <svg width="41" height="40" viewBox="0 0 41 40" fill="none">
                                            <rect x="0.5" width="40" height="40" rx="12" fill="#00CCC6"/>
                                            <path d="M20.5 25V11" stroke="white" strokeWidth="1.5"
                                                  strokeLinecap="round"/>
                                            <path
                                                d="M29.5 25C29.5 27.209 27.709 29 25.5 29H15.5C13.291 29 11.5 27.209 11.5 25"
                                                stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
                                            <path d="M25.499 20L20.498 25.001L15.498 20" stroke="white"
                                                  strokeWidth="1.5" strokeLinecap="round"/>
                                        </svg>
                                    </div>
                                </>
                            )}
                            <button
                                type="button"
                                className={s.removeBtn}
                                aria-label="Удалить блок видео"
                                onClick={() => removeVideoBlock(i)}
                            >
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <rect width="32" height="32" rx="12" fill="#1B1D1D" fillOpacity="0.4" />
                                    <path
                                        d="M23.001 21.9438C23.2939 22.2367 23.2939 22.7115 23.001 23.0044C22.7081 23.2973 22.2333 23.2973 21.9404 23.0044L15.999 17.0631L10.0577 23.0044C9.76478 23.2973 9.28991 23.2973 8.99701 23.0044C8.70412 22.7115 8.70412 22.2367 8.99701 21.9438L14.9384 16.0024L8.99758 10.0616C8.70469 9.76869 8.70469 9.29381 8.99758 9.00092C9.29047 8.70803 9.76535 8.70803 10.0582 9.00092L15.999 14.9417L21.9398 9.00092C22.2327 8.70803 22.7076 8.70803 23.0005 9.00092C23.2934 9.29382 23.2934 9.76869 23.0005 10.0616L17.0597 16.0024L23.001 21.9438Z"
                                        fill="white"/>
                                </svg>
                            </button>
                        </div>

                        <div className={s.videoMeta}>
                            <label className={s.inputLabel}>{`Название видео ${i + 1}`}</label>
                            <input
                                type="text"
                                className={s.textInput}
                                placeholder="Введите название видео..."
                                value={v.title}
                                onChange={(e) => handleTitle(i, e.target.value)}
                            />

                            {/* чекбокс демо */}
                            <label className={s.demoLabel}>
                                <input
                                    type="checkbox"
                                    checked={v.isDemo ?? false}
                                    onChange={() => handleDemoToggle(i)}
                                />
                                Демо видео
                            </label>
                        </div>
                    </div>
                ))}
                <button type="button" className={s.addButton} onClick={addSlot}>
                    {`Добавить видео ${videos.length + 1}`}
                </button>
            </div>
        </div>
    );
};
